"use strict";
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * eloomi-learning-persona (2.0)
 * - This service is using new eloomi project structure. You should be able to make HTTP calls from this UI.
 *
 * The version of the OpenAPI document: 2.0

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LearningObjectsApiFactory = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * LearningObjectsApi - axios parameter creator
 * @export
 */
const LearningObjectsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} learningObjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjectDetails: async (learningObjectId, options = {}) => {
            // verify required parameter 'learningObjectId' is not null or undefined
            (0, common_1.assertParamExists)('getLearningObjectDetails', 'learningObjectId', learningObjectId);
            const localVarPath = `/learning/persona/content-store/learning-objects/{learningObjectId}`
                .replace(`{${"learningObjectId"}}`, encodeURIComponent(String(learningObjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "2.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjectLanguages: async (options = {}) => {
            const localVarPath = `/learning/persona/content-store/learning-objects/languages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "2.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} learningObjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjectPreview: async (learningObjectId, options = {}) => {
            // verify required parameter 'learningObjectId' is not null or undefined
            (0, common_1.assertParamExists)('getLearningObjectPreview', 'learningObjectId', learningObjectId);
            const localVarPath = `/learning/persona/content-store/learning-objects/{learningObjectId}/preview`
                .replace(`{${"learningObjectId"}}`, encodeURIComponent(String(learningObjectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "2.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjectProviders: async (options = {}) => {
            const localVarPath = `/learning/persona/content-store/learning-objects/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "2.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjectTopics: async (options = {}) => {
            const localVarPath = `/learning/persona/content-store/learning-objects/topics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "2.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {string} [collection]
         * @param {Array<number>} [contentGroup]
         * @param {Array<number>} [durationMin]
         * @param {Array<number>} [durationMax]
         * @param {Go1EventType} [event]
         * @param {string} [eventStartDate]
         * @param {string} [eventEndDate]
         * @param {Array<Go1FacetType>} [facets]
         * @param {string} [keyword]
         * @param {Array<string>} [language]
         * @param {Array<string>} [locationCountry]
         * @param {Array<string>} [locationLocality]
         * @param {Array<string>} [locationThoroughfare]
         * @param {number} [priceMin]
         * @param {number} [priceMax]
         * @param {string} [providers]
         * @param {string} [sort]
         * @param {boolean} [subscribed]
         * @param {Array<number>} [subscribedGroup]
         * @param {Array<string>} [tags]
         * @param {Array<Go1Type>} [type]
         * @param {Array<string>} [topics]
         * @param {Array<number>} [id]
         * @param {Array<Go1EntryLevel>} [entryLevel]
         * @param {string} [updatedAfter]
         * @param {boolean} [includeCustomFields]
         * @param {string} [customAttributes]
         * @param {boolean} [scroll]
         * @param {string} [scrollId]
         * @param {boolean} [isDecommissioned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjects: async (page, pageSize, collection, contentGroup, durationMin, durationMax, event, eventStartDate, eventEndDate, facets, keyword, language, locationCountry, locationLocality, locationThoroughfare, priceMin, priceMax, providers, sort, subscribed, subscribedGroup, tags, type, topics, id, entryLevel, updatedAfter, includeCustomFields, customAttributes, scroll, scrollId, isDecommissioned, options = {}) => {
            const localVarPath = `/learning/persona/content-store/learning-objects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["api-version"] = "2.0";
            // authentication apiToken required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }
            if (collection !== undefined) {
                localVarQueryParameter['Collection'] = collection;
            }
            if (contentGroup) {
                localVarQueryParameter['ContentGroup'] = contentGroup;
            }
            if (durationMin) {
                localVarQueryParameter['DurationMin'] = durationMin;
            }
            if (durationMax) {
                localVarQueryParameter['DurationMax'] = durationMax;
            }
            if (event !== undefined) {
                localVarQueryParameter['Event'] = event;
            }
            if (eventStartDate !== undefined) {
                localVarQueryParameter['EventStartDate'] = (eventStartDate instanceof Date) ?
                    eventStartDate.toISOString() :
                    eventStartDate;
            }
            if (eventEndDate !== undefined) {
                localVarQueryParameter['EventEndDate'] = (eventEndDate instanceof Date) ?
                    eventEndDate.toISOString() :
                    eventEndDate;
            }
            if (facets) {
                localVarQueryParameter['Facets'] = facets;
            }
            if (keyword !== undefined) {
                localVarQueryParameter['Keyword'] = keyword;
            }
            if (language) {
                localVarQueryParameter['Language'] = language;
            }
            if (locationCountry) {
                localVarQueryParameter['LocationCountry'] = locationCountry;
            }
            if (locationLocality) {
                localVarQueryParameter['LocationLocality'] = locationLocality;
            }
            if (locationThoroughfare) {
                localVarQueryParameter['LocationThoroughfare'] = locationThoroughfare;
            }
            if (priceMin !== undefined) {
                localVarQueryParameter['PriceMin'] = priceMin;
            }
            if (priceMax !== undefined) {
                localVarQueryParameter['PriceMax'] = priceMax;
            }
            if (providers !== undefined) {
                localVarQueryParameter['Providers'] = providers;
            }
            if (sort !== undefined) {
                localVarQueryParameter['Sort'] = sort;
            }
            if (subscribed !== undefined) {
                localVarQueryParameter['Subscribed'] = subscribed;
            }
            if (subscribedGroup) {
                localVarQueryParameter['SubscribedGroup'] = subscribedGroup;
            }
            if (tags) {
                localVarQueryParameter['Tags'] = tags;
            }
            if (type) {
                localVarQueryParameter['Type'] = type;
            }
            if (topics) {
                localVarQueryParameter['Topics'] = topics;
            }
            if (id) {
                localVarQueryParameter['Id'] = id;
            }
            if (entryLevel) {
                localVarQueryParameter['EntryLevel'] = entryLevel;
            }
            if (updatedAfter !== undefined) {
                localVarQueryParameter['UpdatedAfter'] = (updatedAfter instanceof Date) ?
                    updatedAfter.toISOString() :
                    updatedAfter;
            }
            if (includeCustomFields !== undefined) {
                localVarQueryParameter['IncludeCustomFields'] = includeCustomFields;
            }
            if (customAttributes !== undefined) {
                localVarQueryParameter['CustomAttributes'] = customAttributes;
            }
            if (scroll !== undefined) {
                localVarQueryParameter['Scroll'] = scroll;
            }
            if (scrollId !== undefined) {
                localVarQueryParameter['ScrollId'] = scrollId;
            }
            if (isDecommissioned !== undefined) {
                localVarQueryParameter['IsDecommissioned'] = isDecommissioned;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LearningObjectsApi - functional programming interface
 * @export
 */
const LearningObjectsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LearningObjectsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} learningObjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLearningObjectDetails(learningObjectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLearningObjectDetails(learningObjectId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLearningObjectLanguages(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLearningObjectLanguages(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} learningObjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLearningObjectPreview(learningObjectId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLearningObjectPreview(learningObjectId, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLearningObjectProviders(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLearningObjectProviders(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLearningObjectTopics(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLearningObjectTopics(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {string} [collection]
         * @param {Array<number>} [contentGroup]
         * @param {Array<number>} [durationMin]
         * @param {Array<number>} [durationMax]
         * @param {Go1EventType} [event]
         * @param {string} [eventStartDate]
         * @param {string} [eventEndDate]
         * @param {Array<Go1FacetType>} [facets]
         * @param {string} [keyword]
         * @param {Array<string>} [language]
         * @param {Array<string>} [locationCountry]
         * @param {Array<string>} [locationLocality]
         * @param {Array<string>} [locationThoroughfare]
         * @param {number} [priceMin]
         * @param {number} [priceMax]
         * @param {string} [providers]
         * @param {string} [sort]
         * @param {boolean} [subscribed]
         * @param {Array<number>} [subscribedGroup]
         * @param {Array<string>} [tags]
         * @param {Array<Go1Type>} [type]
         * @param {Array<string>} [topics]
         * @param {Array<number>} [id]
         * @param {Array<Go1EntryLevel>} [entryLevel]
         * @param {string} [updatedAfter]
         * @param {boolean} [includeCustomFields]
         * @param {string} [customAttributes]
         * @param {boolean} [scroll]
         * @param {string} [scrollId]
         * @param {boolean} [isDecommissioned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLearningObjects(page, pageSize, collection, contentGroup, durationMin, durationMax, event, eventStartDate, eventEndDate, facets, keyword, language, locationCountry, locationLocality, locationThoroughfare, priceMin, priceMax, providers, sort, subscribed, subscribedGroup, tags, type, topics, id, entryLevel, updatedAfter, includeCustomFields, customAttributes, scroll, scrollId, isDecommissioned, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLearningObjects(page, pageSize, collection, contentGroup, durationMin, durationMax, event, eventStartDate, eventEndDate, facets, keyword, language, locationCountry, locationLocality, locationThoroughfare, priceMin, priceMax, providers, sort, subscribed, subscribedGroup, tags, type, topics, id, entryLevel, updatedAfter, includeCustomFields, customAttributes, scroll, scrollId, isDecommissioned, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
/**
 * LearningObjectsApi - factory interface
 * @export
 */
const LearningObjectsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LearningObjectsApiFp(configuration);
    return {
        /**
         *
         * @param {number} learningObjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjectDetails(learningObjectId, options) {
            return localVarFp.getLearningObjectDetails(learningObjectId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjectLanguages(options) {
            return localVarFp.getLearningObjectLanguages(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} learningObjectId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjectPreview(learningObjectId, options) {
            return localVarFp.getLearningObjectPreview(learningObjectId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjectProviders(options) {
            return localVarFp.getLearningObjectProviders(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjectTopics(options) {
            return localVarFp.getLearningObjectTopics(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {string} [collection]
         * @param {Array<number>} [contentGroup]
         * @param {Array<number>} [durationMin]
         * @param {Array<number>} [durationMax]
         * @param {Go1EventType} [event]
         * @param {string} [eventStartDate]
         * @param {string} [eventEndDate]
         * @param {Array<Go1FacetType>} [facets]
         * @param {string} [keyword]
         * @param {Array<string>} [language]
         * @param {Array<string>} [locationCountry]
         * @param {Array<string>} [locationLocality]
         * @param {Array<string>} [locationThoroughfare]
         * @param {number} [priceMin]
         * @param {number} [priceMax]
         * @param {string} [providers]
         * @param {string} [sort]
         * @param {boolean} [subscribed]
         * @param {Array<number>} [subscribedGroup]
         * @param {Array<string>} [tags]
         * @param {Array<Go1Type>} [type]
         * @param {Array<string>} [topics]
         * @param {Array<number>} [id]
         * @param {Array<Go1EntryLevel>} [entryLevel]
         * @param {string} [updatedAfter]
         * @param {boolean} [includeCustomFields]
         * @param {string} [customAttributes]
         * @param {boolean} [scroll]
         * @param {string} [scrollId]
         * @param {boolean} [isDecommissioned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningObjects(page, pageSize, collection, contentGroup, durationMin, durationMax, event, eventStartDate, eventEndDate, facets, keyword, language, locationCountry, locationLocality, locationThoroughfare, priceMin, priceMax, providers, sort, subscribed, subscribedGroup, tags, type, topics, id, entryLevel, updatedAfter, includeCustomFields, customAttributes, scroll, scrollId, isDecommissioned, options) {
            return localVarFp.getLearningObjects(page, pageSize, collection, contentGroup, durationMin, durationMax, event, eventStartDate, eventEndDate, facets, keyword, language, locationCountry, locationLocality, locationThoroughfare, priceMin, priceMax, providers, sort, subscribed, subscribedGroup, tags, type, topics, id, entryLevel, updatedAfter, includeCustomFields, customAttributes, scroll, scrollId, isDecommissioned, options).then((request) => request(axios, basePath));
        },
    };
};
exports.LearningObjectsApiFactory = LearningObjectsApiFactory;
//# sourceMappingURL=learning-objects-api.js.map